export default __webpack_public_path__ + "static/media/CheckCircleOutlined.4ad3643a.svg";